export interface TopDestination {
    cityId: number;
    cityName: string;
    cityUrl: string;
    countryId: number;
    countryName?: string;
    imageUrl: string;
    imageUrls?: {
        w328h328?: string;
        w345h345?: string;
        w390h168?: string;
        w396h298?: string;
        w694h298?: string;
        w200h200?: string;
        w762h328?: string;
        w100h100?: string;
    };
    noOfHotels?: number;
    formattedNoOfActivities?: string;
    propertyText?: string;
    activityId?: number;
    activityName?: string;
    cityNameEnglish?: string;
    countryNameEnglish?: string;
}

export interface DomesticCountry {
    languageId: number;
    countryId: number;
    countryName: string;
    countryNameIn: string;
    topDomesticCityFallback: string;
    topInternationalCityFallback: string;
}

export interface TopDestinationsGroup {
    topDestinations: TopDestination[];
    topDomesticDestinations: TopDestination[];
    domesticCountry?: DomesticCountry;
}

export enum TopDestinationType {
    Default = 'Default',
    Domestic = 'Domestic',
    International = 'International',
}
